<template>
  <div>
    <!-- Page Loading -->
    <div class="loading" v-if="isLoading == true">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <!-- Export Buttons -->
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <router-link
            v-if="$can('generate_voucher')" 
              :to="{name: 'Add Voucher'}"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Generate
          </router-link>&nbsp;
          <b-dropdown
            id="dropdown-dropright" 
            dropright
            text="Export" 
            variant="success" 
            class="m-2" 
            v-if="$can('export-voucher')"
              :disabled="!hasAppliedFilter || exportLoading"
          >
              <template #button-content>
                <div
                  class="d-inline-flex sk-three-bounce custom-loading-bounce"
                  v-if="exportLoading"
                >
                  <div class="sk-child sk-bounce1"></div>
                  <div class="sk-child sk-bounce2"></div>
                  <div class="sk-child sk-bounce3"></div>
                </div>
                <span class="mr-2" v-else>Export</span>
              </template>

              <b-dropdown-item @click="exportTable" :disabled="exportLoading">Export All</b-dropdown-item>
              <b-dropdown-item @click="exportMultiple" :disabled="exportLoading">
                Export Voucher IDR Multiple Redeem
              </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <!-- Filters -->
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            description="Searchable: voucher code, voucher name, voucher prefix"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-dropdown
                  :text="typeSearch"
                  v-model="typeSearch"
                  variant="secondary"
                >
                  <b-dropdown-item
                    v-for="(item, index) in typeSearchs"
                    :key="index"
                    @click="onChangeDropdown(item)"
                  >
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>

              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                  :placeholder="placeholder"
              ></b-form-input>

              <b-input-group-append>
                <b-button
                  variant="secondary"
                  type="button"
                  @click="resetFilter"
                >
                  Reset
                </b-button>
              </b-input-group-append>
          </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Date :"
            label-for="daterange"
          >
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker 
                id="daterange" 
                :start="startDate" 
                :end="endDate"
                :type="'clear'"
                :timePicker="false"
                :autoUpdate="false"
                @picker="doDateFilter"
              ></range-picker>
              <b-input-group-append>
                <b-button 
                  type="button" 
                  variant="secondary" 
                  @click="resetDateFilter">Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          :disabled="stateButton"
          :style="buttonStyle"
          class="mb-2"
          @click="onFetch"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>
    <!-- Table Skeleton Loading -->
    <b-skeleton-table
      v-if="tableLoading"
        :rows="10"
        :columns="11"
        :table-props="{ bordered: true }"
    ></b-skeleton-table>
    <!-- Vuetable -->
    <vuetable
      v-else
      ref="vuetable"
        :api-mode="false"
        :fields="fields"
        :per-page="limit"
        :data-manager="dataManager"
      pagination-path="pagination"
        :muti-sort="true"
        :sort-order="sortOrder"
        :no-data-template="isParams ? defaultTemplate : noDataTemplate"
      >
      <template slot="code-slot" slot-scope="prop">
        <b-badge pill variant="dark" class="badge--code">{{ prop.rowData.code }}</b-badge>
      </template>
      <template slot="name-slot" slot-scope="prop">
        <span>{{ prop.rowData.name }}</span>
      </template>
      <template slot="start_from-slot" slot-scope="prop">
        <span
          :style="[timeNow >= prop.rowData.end_to ? {'color' : 'red'} : {'color' : 'green'}]">
          {{ prop.rowData.start_from }}
        </span>
      </template>
      <template slot="end_to-slot" slot-scope="prop">
        <span
          :style="[timeNow >= prop.rowData.end_to ? {'color' : 'red'} : {'color' : 'green'}]">
          {{ prop.rowData.end_to }}
        </span>
      </template>
      <template slot="program_start-slot" slot-scope="prop">
        <span
          :style="[timeNow >= prop.rowData.program_end ? {'color' : 'red'} : {'color' : 'green'}]">
          {{ prop.rowData.program_start }}
        </span>
      </template>
      <template slot="program_end-slot" slot-scope="prop">
        <span 
          :style="[timeNow >= prop.rowData.program_end ? {'color' : 'red'} : {'color' : 'green'}]">
          {{ prop.rowData.program_end }}
        </span>
      </template>
      <template slot="amount-slot" slot-scope="prop">
        <span v-if="prop.rowData.voucher_type === 'gold'">
          {{ prop.rowData.amount }} Gram
        </span>
        <span v-else>
          {{ prop.rowData.amount | currency }}
        </span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions">
          <button 
            v-if="$can('detail_voucher')" 
            class="btn btn-info" 
            @click="onAction('detail-item', prop.rowData)">Detail
          </button>&nbsp;
          <b-img 
            v-show="prop.rowData.qrcode_path !== null" 
            rounded 
            alt="Rounded image" 
              :src="require('../../../assets/img/qrcode.png')" 
            width="30px" 
            height="30px;" 
            @click="onAction('download-item', prop.rowData)">
          </b-img>&nbsp;
          <button 
            v-if="$can('delete_voucher')" 
            class="btn btn-danger" 
            @click="onAction('delete-item', prop.rowData)">
            <i class="fa fa-trash-o"></i>
          </button>
        </div>
      </template>
    </vuetable>
    <!-- Pagination -->
    <div class="vuetable-pagination ui basic segment grid">
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="currentPage === 1" @click="onMovePage('first')">
            <i
              v-if="currentPage === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="currentPage === 1" @click="onMovePage('prev')">
            <i v-if="currentPage === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.currentPage }}</div>
          <button :disabled="data.length < 10" @click="onMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import moment from 'moment/src/moment'
  import _ from 'lodash'

  Vue.use(Vuetable)

  export default {
    components: { Vuetable },
    prop: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    data() {
      return {
        data: [],
        limit: 10,
        page: 1,
        currentPage: 1,
        paginationInfo: 'No relevant data',
        startDate: '',
        endDate: '',
        isLoading: false,
        tableLoading: false,
        exportLoading: false,
        hasAppliedFilter: false,
        filterText: '',
        typeSearch: 'Voucher Name',
        placeholder: 'Search by Voucher Name',
        typeSearchs: [
          {
            value: 'Voucher Name',
            text: 'Voucher Name',
            placeholder: 'Search by Voucher Name'
          },
          {
            value: 'Voucher Code',
            text: 'Voucher Code',
            placeholder: 'Search by Voucher Code'
          },
          {
            value: 'Voucher Prefix',
            text: 'Voucher Prefix',
            placeholder: 'Search by Voucher Prefix'
          }
        ],
        timeNow: moment().format('YYYY-MM-DD hh:mm:ss'),
        errors: {
          code: '',
          message: '',
          status: ''
        },
        sort: 'created_at|desc',
        sortOrder: [
          {
            field: 'created_at',
            sortField: 'created_at',
            direction: 'desc'
          }
        ],
        moreParams: {},
        fields: [
          {
            name: 'code-slot',
            sortField: 'code',
            title: 'Voucher Code'
          },
          {
            name: 'name-slot',
            sortField: 'name',
            title: 'Voucher Name'
          },
          {
            name: 'start_from-slot',
            sortField: 'start_from',
            title: 'Voucher Expired Start'
          },
          {
            name: 'end_to-slot',
            sortField: 'end_to',
            title: 'Voucher Expired End',
          },
          {
            name: 'program_start-slot',
            sortField: 'program_start',
            title: 'Program Start'
          },
          {
            name: 'program_end-slot',
            sortField: 'program_end',
            title: 'Program End'
          },
          {
            name: 'amount-slot',
            sortField: 'amount',
            titleClass: 'center aligned',
            dataClass: 'right aligned',
            title: 'Voucher Amount',
          },
          {
            name: 'available_status',
            titleClass: 'center aligned',
            dataClass: 'center aligned',
            title: 'Available',
            formatter: this.activeLabel
          },
          {
            name: 'actions-slot',
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
        ],
        noDataTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
        defaultTemplate:
          '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>'
      }
    },
    computed: {
      stateButton() {
        return !this.filterText && !this.startDate && !this.endDate
      },
      buttonStyle() {
        return {
          background: !this.stateButton ? "#7565F6" : "#c8ced3",
          color: !this.stateButton ? "#FFFFFF" : "inherit"
        };
      },
      isParams() {
        const params = this.moreParams

        if (this.filterText) params.filter = this.filterText

        if (this.typeSearch && this.filterText) {
          params.typeFilter = this.getSearchTypeParam(this.typeSearch || '')
        }

        return !(
          Object.entries(params).filter(Boolean).length == 0
        )
      }
    },
    watch: {
      data() {
        this.$refs.vuetable?.refresh()
      }
    },
    methods: {
      getTableQueryParams(skipDate = false) {
        const params = this.moreParams
        
        if (this.filterText) params.filter = this.filterText

        if (this.typeSearch && this.filterText) {
          params.typeFilter = this.getSearchTypeParam(this.typeSearch || '')
        }

        if (skipDate) {
          delete params?.start_from
          delete params?.end_to
        }

        return Object.entries(params)
          .filter(Boolean)
          .map(([key, value]) => `${key}=${value}`)
          .join('&')
      },
      onChangeDropdown(item) {
        this.typeSearch = item.value;
        this.placeholder = item.placeholder;
        this.moreParams = {
          ...this.moreParams,
          'typeFilter': this.getSearchTypeParam(item?.value || '')
        }
      },
      doFilter () {
        this.$events.$emit('filter-set', this.filterText)
      },
      resetFilter () {
        this.filterText = ''
        delete this.moreParams?.typeFilter
        this.hasAppliedFilter = false
        this.$events.$emit('filter-reset')
      },
      exportTable() {
        if (this.exportLoading) return
        this.exportLoading = true
        const skipDate = true
        const requestParams = this.getTableQueryParams(skipDate)

        this.$http.get(
          `voucher${this.startDate ? `/${this.startDate}` : ''}${this.endDate ? `/${this.endDate}` : ''}` +
          `${requestParams ? `?${requestParams}` : ''}`
        )
          .then((result) => {
            const exportPath = result.data.meta?.data;
            window.location.href = exportPath;
          }).catch((error) => {
            this.handleLoadError(error)
          }).finally(() => {
            this.exportLoading = false
          })
      },
      exportMultiple() {
        if (this.exportLoading) return
        this.exportLoading = true
        const skipDate = true
        const requestParams = this.getTableQueryParams(skipDate)
        
        this.$http.get(
          `voucher-serveral${this.startDate ? `/${this.startDate}` : ''}${this.endDate ? `/${this.endDate}` : ''}` +
          `?sort=${encodeURIComponent(this.sort)}` +
          `${requestParams ? `&${requestParams}` : ''}`
        )
          .then((result) => {
            const exportPath = result.data.meta.data;
            window.location.href = exportPath;
          }).catch((error) => {
            this.handleLoadError(error)
          }).finally(() => {
            this.exportLoading = false
          })
      },
      getSearchTypeParam(value) {
        if (value === 'Voucher Code') return 'code'
        if (value === 'Voucher Name') return 'name'
        return 'prefix'
      },
      onFetch() {
        this.tableLoading = true
        const requestParams = this.getTableQueryParams()

        this.$http.get(
          `vouchers?sort=${encodeURIComponent(this.sort)}&page=${this.page}` +
          `&per_page=10${requestParams ? `&${requestParams}` : ''}`
        )
          .then((response) => {
            // response.data.data assumed to be array
            this.data = response.data.data || response.data || []
            // if server provides current_page use it
            this.currentPage = response.data.current_page || 1
            // keep page in sync with currentPage
            this.page = this.currentPage
            const datasCount = this.data.length
            const startIndex = (this.currentPage - 1) * this.limit
            // endIndex should not exceed total items across pages; compute visible end index
            const endIndex = datasCount > 0 ?
              Math.min(startIndex + this.limit, startIndex + datasCount) : 0
            this.paginationInfo = datasCount > 0 ?
              `Displaying ${startIndex + 1} to ${endIndex}` : 'No relevant data'
            this.hasAppliedFilter = true
            this.tableLoading = false
          })
          .catch((err) => {
            this.tableLoading = false
            this.handleLoadError(err)
          })
      },
      dataManager(sortOrder, pagination) {
        let local = this.data

        if (sortOrder.length > 0) {
          const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`

          if (this.sort !== newSort) {
            this.sort = newSort
            this.onFetch()
          }
        }

        pagination = this.$refs.vuetable.makePagination(local.length, this.limit)

        let from = pagination.from - 1
        let to = from + this.limit

        return {
          pagination: pagination,
          data: local.length > 0 ? _.slice(local, from, to) : []
        }
      },
      handleLoadError(error) {
        this.isLoading = false;
        this.tableLoading = false;
        const resp = error && error.response
        const meta = resp && resp.data && resp.data.meta
        this.errors.code = meta && meta.code ? meta.code : (resp && resp.status) || ''
        this.errors.message = meta && meta.message ? 
          meta.message : (resp && resp.data && resp.data.message) || ''
        this.errors.status = this.errors.code

        if (this.errors.code == 401) {
          if (localStorage.getItem('access_token') !== null) {
            localStorage.removeItem('access_token');
            this.$swal.fire(
              'Your session expired!',
              'Your session has expired. Please login again to access this page!',
              'error'
            ).then(() => {
              this.$router.push("/login")
            })
          }
        } else if (this.errors.code == 403) {
          this.$router.push("/403")
        } else if (this.errors.code == 500) {
          this.$router.push("/500")
        } else {
          this.$swal.fire(
            "Error!",
            this.errors.message || "Something went wrong. Please try again later.",
            "error"
          )
        }
      },
      activeLabel (value) {
        if (value === true) {
          return '<span class="ui green label"><i class="fa fa-check"></i></span>'
        }
        return '<span class="ui red label"><i class="fa fa-times"></i></span>'
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      // Handle pagination button clicks from template
      onMovePage(eventData) {
        if (eventData === "first") {
        this.page = 1;
        this.onFetch();
      } else if (eventData === "prev") {
        this.page--;
        this.onFetch();
      } else {
        this.page++;
        this.onFetch();
      }
      },
      onAction (action, data) {
        if (action == 'detail-item') {
          this.$router.push({ name: 'Detail Voucher', params: { id: data.id } })
        } else if (action == 'download-item') {
          this.$router.push({ name: 'Qrcode', params: { id: data.id } })
        } else {
          this.$swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this Voucher!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
              this.$http.delete(`delete-voucher/` + data.id)
                .then(() => {
                  this.$swal.fire(
                    'Deleted!',
                    'Voucher has been deleted.',
                    'success'
                  ).then(() => {
                    location.reload();
                  })
                }).catch((error) => {
                  if (error.response) {
                    this.errors.code = error.response.status;
                    this.errors.message = error.response.data.meta.message;
                    this.errors.status = error.response.data.meta.code;
                  }
                })
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.$swal.fire(
                'Cancelled',
                'Voucher was successfully canceled for deletion!',
                'error'
              )
            }
          })
        }
      },
      onFilterSet (filterText) {
        this.moreParams = { ...this.moreParams, 'filter': filterText }
        this.page = 1
        this.onFetch()
      },
      resetDateFilter () {
        this.startDate = ''
        this.endDate = ''
        this.hasAppliedFilter = false
        this.$events.$emit('date-filter-reset')
      },
      doDateFilter(value) {
        this.startDate = value.startDate;
        this.endDate = value.endDate;
        this.$events.fire('date-set', [this.startDate, this.endDate])
      },
      onDateSet() {
        this.moreParams = {
          ...this.moreParams,
          'start_from': this.startDate,
          'end_to': this.endDate
        }
        this.page = 1
      },
      onFilterReset () {
        // eslint-disable-next-line no-unused-vars
        delete this.moreParams?.filter
        this.page = 1
      },
      onDateFilterReset () {
        delete this.moreParams?.start_from
        delete this.moreParams?.end_to
        this.page = 1
      }
    },
    created() {
      this.$events.$on('filter-set', this.onFilterSet)
      this.$events.$on('date-set', this.onDateSet)
      this.$events.$on('filter-reset', this.onFilterReset)
      this.$events.$on('date-filter-reset', this.onDateFilterReset)
    },
    beforeDestroy() {
      this.$events.$off('filter-set', this.onFilterSet)
      this.$events.$off('date-set', this.onDateSet)
      this.$events.$off('filter-reset', this.onFilterReset)
      this.$events.$off('date-filter-reset', this.onDateFilterReset)
    }
  }
</script>
<style>

.badge--code {
  font-size: 10pt !important;
}
/* Loading Bounce */
.custom-loading-bounce {
  width: 60px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

/* Pagination Custom */
.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
